"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.LinkStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2;

var LinkStyled = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  align-items: center;\n  color      : ", ";\n  display    : flex;\n  font-size  : 14px;\n  font-weight: ", ";\n  text-align : left;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n\n  &:hover {\n    cursor         : pointer;\n    text-decoration: underline;\n  }\n"])), function (props) {
  return props.color ? props.color : _palette.palette.link;
}, _widths.font.medium, _widths.widths.base, _widths.widths.base);

exports.LinkStyled = LinkStyled;
LinkStyled.displayName = 'LinkStyled';

var Text = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"])), function (props) {
  return props.icon ? "".concat(_widths.widths.base, "px") : 0;
});

exports.Text = Text;
Text.displayName = 'Text';